/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../../services/internationalization/internationalization_data_dictionary.ts"/>

module DealerwareWebContent {
    "use strict";

    export class EmployeesDashboardController {
        public static $inject : string[] = [
            '$dealerwareSolrSearchEmployeeCollection',
            'CurrentUser',
            '$timeout',
            '$scope',
            '$state',
            '$dealerwareInternationalizationData'
        ];

        public employeeRows: any;
        public modal: any;
        public labels: { generic?: string };

        constructor(public $dealerwareSolrSearchEmployeeCollection : any,
                    public CurrentUser : any,
                    public $timeout : any,
                    public $scope : any,
                    public $state : any,
                    public $dealerwareInternationalizationData: DealerwareWebServices.DealerwareInternationalizationData) {
            var _self = this;
            this.getLabels('errorMessages');
        }

        public getLabels(module: string) : void {
            const _self = this;
            this.$dealerwareInternationalizationData
                .getLabels()
                .then(function(res) {
                    _self.labels = _self.$dealerwareInternationalizationData.getLabelsByModule(res.data, module);
                },
                function() {}
            );
        }

        public goToEmployeeDetails(record : any) : void {
            this.$state.go('shortcuts.employeeDetails',{employeeId: record.data.id});
        }

        public openCreateEmployee() : void {
            this.modal.show();
        }

        public closeCreateEmployee() : void {
            this.modal.hide();
        }

        public onCreateEmployeeSuccess(employee: any) : void {
            this.goToEmployeeDetails(employee);
        }

        public onCreateEmployeeError() : void {
            alert(this.labels.generic);
        }
    }

    getDealerwareWebContentModule().controller('EmployeesDashboardController', EmployeesDashboardController);

}
